module.exports = __webpack_public_path__ + "media/images/application2/AppForm__checkbox-788e60cb023b2dc82cd26a2cfe9f2f3f.svg";